module.exports = __webpack_public_path__ + "img/lx.d9fa1069.png";